// ─── Fixed Header Text ─────────────────────────────────────────────────────────
// Title and subtitle are the same across all HrSkillsBridger group pages.

export const GROUP_PAGE_TITLE = "Group -";
export const GROUP_PAGE_SUBTITLE = "Multiple businesses, multiple locations, multiple functions, multiple job-grades, multiple roles, multiple employees.";

// ─── Navigation Tab Labels ─────────────────────────────────────────────────────

export const HR_TAB_LABELS = {
  JOBS_LIBRARY: "Jobs Library",
  SKILLS_BRIDGER: "Skills Bridger",
  LEARNING_CATALYST: "Learning Catalyst",
  TALENT_MOBILITY: "Talent Mobility",
};
